import { Component } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SharedService } from '../../services/shared.service';
import { ExternalUserCheckService } from '../../services/external-user-check-service/external-user-check-service.service';

@Component({
  selector: 'app-left-nav',
  imports: [CommonModule, RouterModule],
  templateUrl: './left-nav.component.html',
  styleUrl: './left-nav.component.scss'
})
export class LeftNavComponent {
  activeSubmenu: string | null = null;
  isExternalUser: boolean = false;
  constructor(
    private router: Router,
    private readonly sharedService: SharedService,
    private readonly externalUserCheckService: ExternalUserCheckService
  ) {}

  ngOnInit() {
    this.isExternalUser = this.externalUserCheckService.isExternalUser();
  }

  toggleNav() {
    const sidenav = document.getElementById('sidenav')!;
    if (sidenav.style.width === '128px') {
      sidenav.style.width = '0';
    } else {
      sidenav.style.width = '128px';
    }
  }

  navigateMenu(destination: string) {
    switch (destination) {
    case 'orders': 
      this.toggleSubmenu('orders');
      const currentPath = this.router.url;
      this.sharedService.setOrderSearchTerm(null);
      this.sharedService.OrderGridParams.first = 0;
      this.sharedService.OrderGridParams.rowsPerPage = 10;
      this.sharedService.OrderGridParams.sortField = 'number';
      this.sharedService.OrderGridParams.sortOrder = -1;
      this.sharedService.OrderGridParams.updatedFilterValues = false;
      this.sharedService.OrderGridParams.accountName =  [];
      this.sharedService.OrderGridParams.createdBy =  [];
      this.sharedService.OrderGridParams.orderOwner = [];
      this.sharedService.OrderGridParams.orderType = [];
      this.sharedService.OrderGridParams.clientName = [];
      if (currentPath?.includes('/home/landing-page')) {
        this.router.navigate(['/home']);
      } else {
        this.router.navigate(['/home/landing-page']);
      }
      break;
    case 'account-contacts':
        this.router.navigate(['/home/account-contacts']);
        break;
      case 'client-contacts':
        this.router.navigate(['/home/client-contacts']);
        break;
      case 'contacts':
        this.router.navigate(['/contacts']);  
        break;
  }
  }

  toggleSubmenu(menu: 'account' | 'client' | 'orders'): void {
    if(this.activeSubmenu === menu && menu === 'orders') {
      this.activeSubmenu = null;
    }
    else {
      this.activeSubmenu = this.activeSubmenu === menu ? null : menu;
    }
  }

}
